import { errorId } from '~/helpers/forms/error-aria'

/** Message d'erreur d'un champ, à l'identifiant que `errorAria` fait citer au champ. */
function FieldError({ fieldId, message }: { fieldId: string, message?: string }) {
  if (!message) return null
  return <p id={errorId(fieldId)} className="text-sm text-error-text">{message}</p>
}

export default FieldError
